import {Component, forwardRef, HostListener, Input} from "@angular/core";
import {FUIAbstractPill} from "../../framework/abstract-pill";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUITextPillComponent),
            multi: true
        }
    ],
    selector: "fui-text-pill",
    styleUrls: ["./text-pill.component.scss"],
    templateUrl: "./text-pill.component.html"
})
export class FUITextPillComponent extends FUIAbstractPill {
    /**
     * Indicates if the pill can be removed
     */
    @Input() public removable: boolean;
}
